<template>
    <div
        class="product-title text-center text-md-start"
        :class="{
            'title-compact': compact
        }"
    >
        <div
            class="d-flex justify-center justify-md-start"
        >
            <component
                v-if="!isLogoLoadError && product.logo"
                :is="tagHeader"
                class="line-height-0 pa-0 ma-0"
            >
                <Logo
                    :logo="product.logo"
                    :font-size-px="fontSizePx"
                    @on-error="onLogoLoadErr"
                ></Logo>
            </component>
            <component
                v-else
                :is="tagHeader"
                ref="elProductTitle"
                class="line-height-normal flex-grow-0 pa-0 ma-0"
                :style="{
                    fontSize: `${fontSizePx}px`
                }"
                :class="{
                    'text-uppercase': !naturalCase,
                    'font-weight-medium': noBold
                }"
            >
                {{ product.name }}
            </component>
        </div>
        <h4
            v-if="product.tagline"
            v-html="product.tagline"
            class="font-size-6 mt-1 mt-md-2 mb-0"
            :class="{
                'font-weight-regular': noBold,
                'font-weight-medium': !noBold
            }"
        ></h4>
    </div>
</template>

<script lang="ts" setup>
    import type { Product } from '~/types';
    import Logo from '~/components/common/Logo/Logo.vue';

    const props = withDefaults(
        defineProps<{
            product: Product;
            compact?: boolean;
            fontSizePx?: number;
            pageTitle?: boolean;
            noBold?: boolean;
            naturalCase?: boolean;
        }>(),
        {
            compact: false,
            fontSizePx: 32,
            naturalCase: false
        }
    );

    const tagHeader = computed(() => !!props.pageTitle ? 'h1' : 'h3');
    const isLogoLoadError = ref<boolean>(false);

    function onLogoLoadErr(e: Event): void {
        isLogoLoadError.value = true;
    }
</script>

<style lang="scss">
.product-title {
    h3 {
        font-size: 2rem;
        line-height: 1;
    }

    // NOTE: No margin-top here — the tagline spacing comes from the mt-1/mt-md-2
    // utilities on the element. Under Vuetify 3 those were `!important` and always
    // won; in Vuetify 4 they live in the vuetify-utilities cascade layer, so any
    // margin-top set here (unlayered) would silently override them.
    h4 {
        font-size: 1.4rem;
    }

    &.title-compact {
        h3 {
            font-size: 1.6rem;
        }

        h4 {
            font-size: 1.2rem;
        }
    }
}
</style>
